import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLine } from "@/components/Reveal";

const CTABand = () => (
  <section className="noise relative overflow-hidden bg-primary py-24 md:py-32" data-testid="cta-band">
    <div
      aria-hidden="true"
      className="absolute -right-32 -top-32 h-[480px] w-[480px] rounded-full border-[60px] border-white/10"
    />
    <div
      aria-hidden="true"
      className="absolute -bottom-40 -left-24 h-[380px] w-[380px] rounded-full bg-white/5"
    />
    <div className="relative mx-auto max-w-7xl px-6">
      <Reveal>
        <span className="eyebrow-dark">Start a conversation</span>
      </Reveal>
      <h2 className="mt-8 max-w-4xl font-display text-[clamp(2.1rem,4.6vw,4rem)] font-semibold leading-[1.04] tracking-tight text-white">
        <MaskedLine>Let&rsquo;s discuss what you</MaskedLine>
        <MaskedLine delay={0.08}>need to build or improve.</MaskedLine>
      </h2>
      <Reveal delay={0.15}>
        <p className="mt-7 max-w-xl text-lg leading-relaxed text-white/75">
          Tell us about your project, your current environment and the challenges you want to
          address.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <Link
            to="/contact"
            data-testid="cta-contact-button"
            className="btn btn-light"
          >
            Contact TecKube
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTABand;
